import React, { FC } from 'react';
import MoreButton from '@components/common/moreButton';
import { useOperatorPanelSettingsWrapperContext } from '@components/operatorPanel/components/OperatorPanelSettings/components/OperatorPanelSettingsWrapper/hooks';
import { SimpleOnPress } from '@interfaces/base';

export interface MoreButtonWrapperProps extends SimpleOnPress {
  testID?: string;
}

const MoreButtonWrapper: FC<MoreButtonWrapperProps> = ({ onPress, testID }) => {
  const { C, scale } = useOperatorPanelSettingsWrapperContext();

  return <MoreButton C={C} onPress={onPress} scale={scale} testID={testID} />;
};

export default MoreButtonWrapper;
